import IconClose from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import BazarButton from "components/BazarButton";
import BazarIconButton from "components/BazarIconButton";
import { FlexBox } from "components/flex-box";
import LazyImage from "components/LazyImage";
import { H2, Span, Tiny } from "components/Typography";
import { FC } from "react";

type Props = {
  isVisible: boolean;
  image: string;
  message: string;
  subMessage?: string;
  codeMessage?: string;
  buttonText: string;
  onClickButton: () => void;
  onClickClose: () => void;
};

export const DialogBase: FC<Props> = ({
  isVisible,
  image,
  message,
  subMessage,
  buttonText,
  codeMessage,
  onClickClose,
  onClickButton,
}) => {
  return (
    <Dialog open={isVisible} fullWidth={true} maxWidth="xs">
      <DialogContent>
        <FlexBox justifyContent="flex-end">
          <BazarIconButton onClick={onClickClose}>
            <IconClose />
          </BazarIconButton>
        </FlexBox>
        <FlexBox flexDirection="column" mt={1}>
          <LazyImage
            src={image}
            width="40%"
            height="20%"
            layout="responsive"
            objectFit="contain"
          />
          <H2 mb={1} fontWeight="600" color="text.secondary" textAlign="center">
            {message}
          </H2>
          <Span mb={1} color="grey.600" textAlign="center">
            {subMessage}
          </Span>
          <Tiny mb={1} color="grey.600" textAlign="center">
            {codeMessage}
          </Tiny>
          <BazarButton
            type="submit"
            color="primary"
            variant="contained"
            onClick={onClickButton}
            sx={{ mt: 2, backgroundColor: "#CF151A" }}
          >
            {buttonText}
          </BazarButton>
        </FlexBox>
      </DialogContent>
    </Dialog>
  );
};
